export default __webpack_public_path__ + "static/mobile-icon-53ac5247792ec6eef97a094613cd1a5e.svg";